import React, { useEffect } from "react";
import { Button, Card, LogoHp } from "@veneer/core";
import LoginConstants from "./VoucherPage/components/Login/LoginConstants";

function removeCookie(name, path = '/') {

    const cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path};`;

    // Remove the cookie
    document.cookie = cookieString;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

const parseJwt = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

const Unauthorized = () => {
    useEffect(() => {
        const checkAuthorization = () => {
            const token = getCookie('auth-token');
            if (token) {
                const decodedToken = parseJwt(token);
                console.log(decodedToken)
                if (decodedToken.status && (decodedToken.status.toLowerCase() == "active")) {
                    window.location.href = '/';
                }
            }
        };

        checkAuthorization();
    }, []);

    const handleSignOut = () => {
        removeCookie('auth-token');
        window.location.href = '/login';
    };

    return (
        <div className="container-fluid">
            <div className="card-wrapper">
                <Card
                    appearance="dropShadow"
                    className="p-5 card-content"
                    content={
                        <React.Fragment>
                            <div className="mt-5">
                                <div style={{ marginBottom: "10px" }}>
                                    <span>You don't have access to PHPSC tool please try again later. <br/> As of now your request has been sent for approval, Please wait while the admin reviews it. </span>
                                </div>
                            </div>
                        </React.Fragment>
                    }
                />
            </div>
        </div>
    );
}

export default Unauthorized;

